(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beauty-in-action-video-slider"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('beauty-video-slider')) {

    class BeautyVideoSlider extends HTMLElement {

      connectedCallback() {

        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';

        this.track = this.querySelector('[data-bia-track]');

        if (!this.track) return;


        this
          .querySelector('[data-bia-previous]')
          ?.addEventListener(
            'click',
            () => this.scroll(-1)
          );


        this
          .querySelector('[data-bia-next]')
          ?.addEventListener(
            'click',
            () => this.scroll(1)
          );


        this
          .querySelectorAll('[data-bia-sound]')
          .forEach((button) => {

            button.addEventListener(
              'click',
              () => this.toggleSound(button)
            );

          });


        this.observer = new IntersectionObserver(
          (entries) => {

            entries.forEach((entry) => {

              const video = entry.target;

              if (entry.isIntersecting) {

                video
                  .play()
                  .catch(() => {});

              } else {

                video.pause();

              }

            });

          },
          {
            root: null,
            threshold: 0.4
          }
        );


        this
          .querySelectorAll('video')
          .forEach(
            (video) => this.observer.observe(video)
          );

      }


      disconnectedCallback() {

        this.observer?.disconnect();

      }


      scroll(direction) {

        const card =
          this.track.querySelector(
            '.bia-video-slider__card'
          );

        if (!card) return;


        const gap =
          parseFloat(
            getComputedStyle(this.track).columnGap
          ) || 0;


        const amount =
          card.getBoundingClientRect().width + gap;


        this.track.scrollBy({
          left: direction * amount,
          behavior: 'smooth'
        });

      }


      toggleSound(button) {

        const video =
          button
            .closest('.bia-video-slider__card')
            ?.querySelector('video');


        if (!video) return;


        const turnSoundOn = video.muted;


        this
          .querySelectorAll('video')
          .forEach((item) => {

            item.muted = true;

          });


        this
          .querySelectorAll('[data-bia-sound]')
          .forEach((item) => {

            item.setAttribute(
              'aria-pressed',
              'false'
            );

            item.setAttribute(
              'aria-label',
              'Turn sound on'
            );

          });


        if (turnSoundOn) {

          video.muted = false;

          video
            .play()
            .catch(() => {});


          button.setAttribute(
            'aria-pressed',
            'true'
          );

          button.setAttribute(
            'aria-label',
            'Turn sound off'
          );

        }

      }

    }


    customElements.define(
      'beauty-video-slider',
      BeautyVideoSlider
    );

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if(Debutify.settings.dbtfy_sticky_header == false) return;

      this.defaultColorScheme = "dbtfy-color-"+this.dataset.colorScheme;
      this.defaultCustomColorScheme = "color-"+this.dataset.customColorScheme;
      this.transparentColorScheme = "dbtfy-color-"+this.dataset.transparentHeaderColorScheme;
      this.transparentCustomColorScheme = "color-"+this.dataset.customTransparentHeaderColorScheme;
      
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {
        top: 0,
        bottom: this.header.offsetHeight
      };

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      if((Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')) || (Debutify.widgets.header.collection_header_transparent && document.body.classList.contains('template-collection'))){
        if (window.pageYOffset <= 0) {
          this.classList.add('dbtfy-header--transparent');
          this.classList.add(this.transparentColorScheme);
          this.classList.add(this.transparentCustomColorScheme);
        } else {
          this.classList.remove('dbtfy-header--transparent');
          if (this.transparentColorScheme) this.classList.remove(this.transparentColorScheme);
          if (this.transparentCustomColorScheme) this.classList.remove(this.transparentCustomColorScheme);

          this.classList.add(this.defaultColorScheme, this.defaultCustomColorScheme);
        }
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      requestAnimationFrame(() => {
        this.onScroll();
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.headerRounded = this.dataset.headerRounded;
        this.headerWidth = this.dataset.headerWidth;
        
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
        
        if((Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')) || (Debutify.widgets.header.collection_header_transparent && document.body.classList.contains('template-collection'))){
          this.classList.add(this.defaultColorScheme,this.defaultCustomColorScheme);
          if(this.classList.contains("dbtfy-header--transparent")){
            this.classList.remove('dbtfy-header--transparent');
          }
         if(this.transparentColorScheme && this.transparentColorScheme !== this.defaultColorScheme){
            this.classList.remove(this.transparentColorScheme);
          }
          if (this.transparentCustomColorScheme && this.transparentCustomColorScheme !== this.defaultCustomColorScheme) {
            this.classList.remove(this.transparentCustomColorScheme);
          }
        }
        if (this.headerRounded == 'true') {
          this.classList.add('header-rounded');
          this.classList.add(`${this.headerWidth}`);
          this.classList.remove('header-rounded-ease-out');
        }
        
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {

        if((Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')) || (Debutify.widgets.header.collection_header_transparent && document.body.classList.contains('template-collection'))){
          this.classList.add(this.transparentColorScheme,this.transparentCustomColorScheme,'dbtfy-header--transparent');
          if(this.defaultColorScheme && this.defaultColorScheme !== this.transparentColorScheme){
            this.classList.remove(this.defaultColorScheme);
          }
          if (this.defaultCustomColorScheme && this.defaultCustomColorScheme !== this.transparentCustomColorScheme) {
            this.classList.remove(this.defaultCustomColorScheme);
          }
        }

        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));

        if (this.headerRounded == 'true') {
          this.classList.remove('header-rounded');
          this.classList.remove(`${this.headerWidth}`);
          this.classList.add('header-rounded-ease-out');
        }
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
